import { render, staticRenderFns } from "./PanoMapOSM.vue?vue&type=template&id=2b21a4cb"
import script from "./PanoMapOSM.vue?vue&type=script&lang=js"
export * from "./PanoMapOSM.vue?vue&type=script&lang=js"
import style0 from "./PanoMapOSM.vue?vue&type=style&index=0&id=2b21a4cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports